import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Typography } from '@mui/material';
import React from 'react';

interface CandidateTableHeaderProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  goBack: () => void;
}

const CandidateTableHeader: React.FC<CandidateTableHeaderProps> = ({
  searchValue,
  onSearchChange,
  goBack,
}) => {
  return (
    <div className="job-queue-header">
      {/* Search and Actions */}
      <div className="job-queue-actions">
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
          }}>
          <IconButton
            sx={{
              '&:hover': {
                backgroundColor: '#f3f4f6',
              },
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              marginRight: '12px',
              padding: '8px',
            }}
            onClick={() => goBack()}>
            <ArrowBackIcon sx={{ color: '#6b7280', fontSize: '20px' }} />
          </IconButton>
          <Typography
            variant="h4"
            sx={{
              color: '#161719',
              fontFamily: 'Red Hat Display Bold',
              fontSize: '16px',
              fontWeight: 'semi-bold',
            }}>
            More
          </Typography>
        </div>

        <div className="action-buttons">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="job-queue-search"
              style={{
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontFamily: 'Red Hat Display Medium',
                fontSize: '14px',
                outline: 'none',
                padding: '8px 12px',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateTableHeader;
